// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"13619f38","453":"7b988526","732":"29619cf3"}[chunkId] + ".chunk.js";
};